import * as FileSystem from 'fs';

export const createFolder = async (date: string, edition: string) => {
  
  try {
    const folderUri = `../epaper/${date}/${edition}/`;
    FileSystem.mkdirSync(folderUri, {recursive: true});
    const imgfolderUri = `../epaper/${date}/img/`;
    FileSystem.mkdirSync(imgfolderUri, {recursive: true});
    return true;
  } catch (error) {
    console.error('Error creating folder:', error);
    throw error;
  }
};

export const createFolderByString = async (folder: string): Promise<boolean> => {

  try {
    const folderUri = `./${folder}/`;
    FileSystem.mkdirSync(folderUri, {recursive: true});
    return true;
  } catch (error) {
    console.error('Error creating folder:', error);
    throw error;
  }
};